import Model from 'flarum/common/Model';

export default class File extends Model {
    filename = Model.attribute<string>('filename');
    humanSize = Model.attribute<string>('humanSize');
    url = Model.attribute<string>('url');
}
